import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AirplaneIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.84792 11.0091L4.52413 13.3512C4.51048 13.45 4.45681 13.5366 4.37826 13.5865L3.98544 13.8364L3.00981 10.6592L1 8.1397L1.39283 7.88985C1.47137 7.83989 1.56627 7.83197 1.65074 7.86833L3.65375 8.73045L6.54946 6.88864L2.77024 2.15116C2.6614 2.01471 2.67356 1.8069 2.79741 1.68699C2.81218 1.6727 2.82819 1.66004 2.84522 1.64921L3.04694 1.52091C3.36774 1.31687 3.7622 1.31321 4.08607 1.51128L9.65202 4.91528L12.6412 3.01402C13.0615 2.74669 13.5457 2.62677 14.0294 2.67021L14.333 2.69748C14.7326 2.73337 15.0301 3.11932 14.9976 3.55953C14.9904 3.65568 14.9676 3.74962 14.9301 3.8368L14.7998 4.14009C14.5921 4.6233 14.2557 5.02535 13.8354 5.29268L10.8462 7.19392L10.7391 14.2063C10.7329 14.6143 10.5328 14.9888 10.212 15.1928L10.0103 15.3211C9.99324 15.332 9.97528 15.3409 9.95666 15.3479C9.80048 15.4061 9.63103 15.3138 9.57819 15.1417L7.74364 9.16729L4.84792 11.0091Z"
		/>
	</svg>
))
